import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';

interface ProgressBarProps {
  current: number;
  total: number;
  label: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ current, total, label }) => {
  const percentage = (current / total) * 100;
  const remaining = total - current;

  return (
    <Box sx={{ marginBottom: '24px' }}>
      <Typography
        sx={{
          fontSize: '0.875rem',
          color: colors.slate[400],
          marginBottom: '8px',
        }}
      >
        {label.replace('{remaining}', remaining.toString())}
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: '300px',
          margin: '0 auto',
          height: '8px',
          backgroundColor: colors.whiteAlpha[10],
          borderRadius: '4px',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            width: `${percentage}%`,
            height: '100%',
            backgroundColor: colors.signalOrange,
            borderRadius: '4px',
          }}
        />
      </Box>
    </Box>
  );
};
